/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { toast } from 'react-toastify';

import cepPromise from 'cep-promise';
import { all, takeLatest, call, put } from 'redux-saga/effects';

import { getCepSuccess, getCepFailure } from './actions';
import { ICepTypes, IGetCepRequestAction } from './types';

function* getCep({ payload }: IGetCepRequestAction) {
  const { cep } = payload;

  try {
    const response = yield call(cepPromise, cep);

    yield put(getCepSuccess(response));
  } catch (err) {
    yield put(getCepFailure());
    toast.error('CEP não encontrado.');
  }
}

export default all([takeLatest(ICepTypes.GET_CEP_REQUEST, getCep)]);
